import { FormFieldTypes } from "../../../../../data/formFieldType";

export const eLearningData = {
    name: 'SgbcElearning',
    initialState: {
        typeofeLearningCourse: '',
        dateofCompletion: "",
        attendanceCertorOtherwise: "",
        CpdPoints: "",
        remarks: "",
        processedBy: "",
        cpdPointsAwarded: "",
        notes: "",
        rejectionReason: ""
    },
    formFields: [
        {
            id: "eLearningInformation",
            lable: "",
            Field_Name: "eLearningInformation",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "eLearningInformation",
            fieldSetting: {
                formTitle: "E-Learning Information",
            },
            style: {
                containerCss: "col-lg-12 mb-4 text-left",
            },
        },
        {
            id: "typeofeLearningCourse",
            lable: "Type of E-Learning Course",
            Field_Name: "Type of E-Learning Course",
            fieldType: FormFieldTypes.INPUT,
            dataField: "typeofeLearningCourse",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        {
            id: "dateofCompletion",
            lable: "Date of Completion",
            Field_Name: "Date of Completion",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "dateofCompletion",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        {
            id: "attendanceCertorOtherwise",
            lable: 'Attendance Cert or otherwise',
            subLable: '(please upload in pdf/jpg format max 2mb)',
            Field_Name: 'file',
            fieldType: FormFieldTypes.FILE,
            dataField: 'attendanceCertorOtherwise',
            fieldSetting: {
                // presentFileName: null,
                placeholder: 'Select Profile Photo',
                isDownloadable: true,
                acceptedFiles: '.jpg, .png , .pdf, .jpeg',
                maxFileSizeInKB: 2048,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        // {
        //     fieldType: FormFieldTypes.SEPARATOR,
        //     style: {
        //         containerCss: "separation-line pl-0 pr-0",
        //     },
        // },
        {
            id: "CpdPoints",
            lable: "CPD Points",
            Field_Name: "CPD Points",
            fieldType: FormFieldTypes.INPUT,
            dataField: "CpdPoints",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space",
            },
        },
        {
            id: "remarks",
            lable: "Remarks",
            Field_Name: "Remarks",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "remarks",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            // validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 col-12 input-margin-space",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "sgbcSection",
            lable: "",
            Field_Name: "sgbcSection",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "sgbcSection",
            fieldSetting: {
                formTitle: "SGBC Section",
            },
            style: {
                containerCss: "col-lg-12 mb-4 text-left",
            },
        },
        {
            id: "processedBy",
            lable: "Processed by",
            Field_Name: "Processed by",
            fieldType: FormFieldTypes.SELECT,
            dataField: "processedBy",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6  "
            }
        },
        {
            id: "cpdPointsAwarded",
            lable: "CPD Points Awarded",
            Field_Name: "CPD Points Awarded ",
            fieldType: FormFieldTypes.SELECT,
            dataField: "cpdPointsAwarded",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6"
            }
        },
        {
            id: "notes",
            lable: "Notes",
            Field_Name: "Notes",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "notes",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3",
            },
        },
        {
            id: "rejectionReason",
            lable: "Rejection Reason",
            Field_Name: "rejectionReason",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "rejectionReason",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3",
            },
        }

    ],
    formSetting: {
        isViewOnly: false
    }
}